export interface PeriodicElement {
  imgConsulente: string;
  consulente: string;
  aziendeAssegate: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  { imgConsulente: 'M', consulente: 'Mario Rossi', aziendeAssegate: '3' },
  { imgConsulente: 'G', consulente: 'Giovanni Verdi', aziendeAssegate: '3' },
  { imgConsulente: 'F', consulente: 'Franco Giusti', aziendeAssegate: '3' },
  { imgConsulente: 'M', consulente: 'Marco Piano', aziendeAssegate: '3' },
  { imgConsulente: 'G', consulente: 'Giacomo Bianchi', aziendeAssegate: '3' },
];
import { Component } from '@angular/core';

/**
 * @title Styling columns using their auto-generated column consulentes
 */
@Component({
  selector: 'app-lista-tabellare-semplice',
  templateUrl: './lista-tabellare-semplice.component.html',
  styleUrls: ['./lista-tabellare-semplice.component.scss'],
  standalone: false,
})
export class ListaTabellareSempliceComponent {
  displayedColumns: string[] = ['consulente', 'aziende-assegate'];
  dataSource = ELEMENT_DATA;
}
